export const API_BASE_URL = process.env.NODE_ENV === "development"
  ? "/api"
  : process.env.REACT_APP_API_BASE_URL;

export const API_PATHS = {
  login: "/accounts/login/",
  logout: "/accounts/logout/",
  refresh: "/accounts/token/refresh/",
  me: "/accounts/me/",
  accountsList: "/accounts/accounts/",
  signup: "/accounts/signup/",
  userPassword: (id) => `/accounts/users/${id}/password/`,
  userAccess: (id) => `/accounts/users/${id}/access/`,
  userDelete: (id) => `/accounts/users/${id}/delete/`,
};
